import styled from 'styled-components'

export const PageContainer = styled.div`
  padding-top: 32px;
  padding-left: 56px;
  padding-right: 56px;
  padding-bottom: 32px;
`

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`

export const FilterSearchWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
`

export const FilterWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const FilterItem = styled.div`
  width: 184px;
  border-radius: 4px;
  margin-right: 24px;
`

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  min-width: 280px;
`

export const TableFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 32px 0 0 0;
`

export const PageTitle = styled.div`
  font-family: Inter, sans-serif;
  font-size: 28px;
  font-weight: 400;
  line-height: 40px;
  color: #202020;
`

export const TableWrapper = styled.div`
  margin: 0;

  table {
    min-width: 1180px;
  }
`

export const ApiKeyCellWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 164px;
`

export const MaskedKey = styled.span`
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 13px;
  letter-spacing: 1px;
  color: #202020;
  max-width: 220px;
  overflow-wrap: anywhere;
  margin-right: 2px;
`

export const IconButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  width: 16px;
  height: 16px;
  color: rgba(32, 32, 32, 0.5);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 0;

  svg {
    display: block;
    width: 16px;
    height: 16px;
  }

  &:hover {
    color: #202020;
  }
`
